import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentAddressBookQueryVariables = Types.Exact<{
  target: Types.Scalars['String']['input'];
}>;


export type CurrentAddressBookQuery = { __typename?: 'Query', addressBook: { __typename?: 'AddressBookListResult', rows?: Array<{ __typename?: 'AddressBookEntry', cn: string, sn: string, givenName?: string | null, telephoneNumber: Array<string>, mail?: string | null, departmentNumber?: string | null, businessCategory?: string | null, description?: string | null, o?: string | null, homePhone?: string | null, mobile?: string | null, uid?: string | null }> | null } };

export type UpdateAddressBookMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  entries: Array<Types.AddressBookEntryData>;
}>;


export type UpdateAddressBookMutation = { __typename?: 'Mutation', bulkAddressBookModification: { __typename?: 'BulkAddressBookModificationResult', added: number, updated: number, deleted: number, errors?: Array<{ __typename?: 'Error', type: string, location: Array<string>, context?: string | null }> | null } };

export type BulkUpdateAddressBookSubscriptionVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  entries: Array<Types.AddressBookEntryData>;
}>;


export type BulkUpdateAddressBookSubscription = { __typename?: 'Subscription', bulkAddressBookModification: { __typename?: 'BulkAddressBookModificationResult', added: number, updated: number, deleted: number, progress: number, errors?: Array<{ __typename?: 'Error', type: string, location: Array<string>, context?: string | null }> | null } };


export const CurrentAddressBookDocument = gql`
    query CurrentAddressBook($target: String!) {
  addressBook(target: $target) {
    rows {
      cn
      sn
      givenName
      telephoneNumber
      mail
      departmentNumber
      businessCategory
      description
      o
      homePhone
      mobile
      uid
    }
  }
}
    `;

/**
 * __useCurrentAddressBookQuery__
 *
 * To run a query within a React component, call `useCurrentAddressBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAddressBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAddressBookQuery({
 *   variables: {
 *      target: // value for 'target'
 *   },
 * });
 */
export function useCurrentAddressBookQuery(baseOptions: Apollo.QueryHookOptions<CurrentAddressBookQuery, CurrentAddressBookQueryVariables> & ({ variables: CurrentAddressBookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAddressBookQuery, CurrentAddressBookQueryVariables>(CurrentAddressBookDocument, options);
      }
export function useCurrentAddressBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAddressBookQuery, CurrentAddressBookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAddressBookQuery, CurrentAddressBookQueryVariables>(CurrentAddressBookDocument, options);
        }
export function useCurrentAddressBookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentAddressBookQuery, CurrentAddressBookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentAddressBookQuery, CurrentAddressBookQueryVariables>(CurrentAddressBookDocument, options);
        }
export type CurrentAddressBookQueryHookResult = ReturnType<typeof useCurrentAddressBookQuery>;
export type CurrentAddressBookLazyQueryHookResult = ReturnType<typeof useCurrentAddressBookLazyQuery>;
export type CurrentAddressBookSuspenseQueryHookResult = ReturnType<typeof useCurrentAddressBookSuspenseQuery>;
export type CurrentAddressBookQueryResult = Apollo.QueryResult<CurrentAddressBookQuery, CurrentAddressBookQueryVariables>;
export const UpdateAddressBookDocument = gql`
    mutation UpdateAddressBook($domainId: Int!, $entries: [AddressBookEntryData!]!) {
  bulkAddressBookModification(domainId: $domainId, entries: $entries) {
    added
    updated
    deleted
    errors {
      type
      location
      context
    }
  }
}
    `;
export type UpdateAddressBookMutationFn = Apollo.MutationFunction<UpdateAddressBookMutation, UpdateAddressBookMutationVariables>;

/**
 * __useUpdateAddressBookMutation__
 *
 * To run a mutation, you first call `useUpdateAddressBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressBookMutation, { data, loading, error }] = useUpdateAddressBookMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function useUpdateAddressBookMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressBookMutation, UpdateAddressBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressBookMutation, UpdateAddressBookMutationVariables>(UpdateAddressBookDocument, options);
      }
export type UpdateAddressBookMutationHookResult = ReturnType<typeof useUpdateAddressBookMutation>;
export type UpdateAddressBookMutationResult = Apollo.MutationResult<UpdateAddressBookMutation>;
export type UpdateAddressBookMutationOptions = Apollo.BaseMutationOptions<UpdateAddressBookMutation, UpdateAddressBookMutationVariables>;
export const BulkUpdateAddressBookDocument = gql`
    subscription BulkUpdateAddressBook($domainId: Int!, $entries: [AddressBookEntryData!]!) {
  bulkAddressBookModification(domainId: $domainId, entries: $entries) {
    added
    updated
    deleted
    progress
    errors {
      type
      location
      context
    }
  }
}
    `;

/**
 * __useBulkUpdateAddressBookSubscription__
 *
 * To run a query within a React component, call `useBulkUpdateAddressBookSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateAddressBookSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkUpdateAddressBookSubscription({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function useBulkUpdateAddressBookSubscription(baseOptions: Apollo.SubscriptionHookOptions<BulkUpdateAddressBookSubscription, BulkUpdateAddressBookSubscriptionVariables> & ({ variables: BulkUpdateAddressBookSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<BulkUpdateAddressBookSubscription, BulkUpdateAddressBookSubscriptionVariables>(BulkUpdateAddressBookDocument, options);
      }
export type BulkUpdateAddressBookSubscriptionHookResult = ReturnType<typeof useBulkUpdateAddressBookSubscription>;
export type BulkUpdateAddressBookSubscriptionResult = Apollo.SubscriptionResult<BulkUpdateAddressBookSubscription>;